import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import PlaylistAssignmentsProgressContainer from './PlaylistAssignmentsProgressContainer';
import { getPlaylistAssignmentsUrl } from '../playlistAssignmentsUtils';
import I18n from 'I18n';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsPortalProgress = ({
  portal: {
    portal: {
      id: portalId,
      companyName: portalName
    },
    progressPercentage,
    playlistId,
    assignees
  },
  url = getPlaylistAssignmentsUrl(playlistId, portalId),
  showAssigneesCount
}) => {
  return /*#__PURE__*/_jsxs(PlaylistAssignmentsProgressContainer, {
    children: [/*#__PURE__*/_jsx(Box, {
      children: url ? /*#__PURE__*/_jsx(UIRouterLink, {
        to: url,
        children: portalName
      }) : portalName
    }), showAssigneesCount && /*#__PURE__*/_jsx(Text, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assigneesCount",
        options: {
          count: assignees.length
        }
      })
    }), /*#__PURE__*/_jsx(Progress, {
      "aria-label": I18n.text('learningCenter.playlistAssignments.teamProgress', {
        progressPercentage: I18n.formatPercentage(progressPercentage)
      }),
      marginBlockEnd: "0",
      use: "success",
      value: progressPercentage
    })]
  });
};
export default PlaylistAssignmentsPortalProgress;